<template>
  <article class="CardPagamento w-100">
    <div class="card">
      <div class="card-body">
        <div
          class="embed-responsive embed-responsive-1by1"
          v-if="$store.state.pedido.url"
          style="height: 100%;min-height: 700px;"
        >
          <iframe
            class="embed-responsive-item"
            :src="$store.state.pedido.url"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-5 row justify-content-end">
      <div class="col-12 col-md-5 col-lg-4">
        <button
          class="btn btn-secondary px-5 mt-4 py-2"
          @click="goToStep('pedido')"
        >
          VOLTAR
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "CardPagamento",
  props: {},
  components: {},
  created() {
    window.scrollTo(0, 0);
    this.intervalFetchPedidoPagamentoStatus = setInterval(() => {
      apiService
        .verificaPagamento(
          this.$store.state.dadosPessoais.pedido.codigoReferencia,
          this.$store.state.pedido.codigoPagamento
        )
        .then(response => {
          if (response.status == "PAGAMENTO_REALIZADO") {
            localStorage.removeItem("carrinho");
            this.$store.dispatch("limparPedido");
            clearInterval(this.intervalFetchPedidoPagamentoStatus);
            this.goToStep("sucesso");
          }
        });
    }, 5000);
  },
  destroyed() {
    clearInterval(this.intervalFetchPedidoPagamentoStatus);
  },
  methods: {
    goToStep(step) {
      clearInterval(this.intervalFetchPedidoPagamentoStatus);
      this.$emit("goToStep", step);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.z-depth-1-half {
  -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
    0 4px 15px 0 rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15) !important;
}
.card {
  border-radius: 0 0 0.25rem 0.25rem;
}
</style>
